import { forwardRef } from "react";
import _ from "lodash";

// @ts-ignore
import LockedOver from "components/LockedOver/LockedOver";

import Item, { ItemType } from "./Item";

import {
  Wrapper,
  Header,
  HeaderTop,
  Category,
  Area,
  Goal,
  Group,
  Col,
  VsText,
  GroupLabel,
  Divider,
  VsImage
} from "./styled";

// @ts-ignore
import vsIcon from "assets/images/journeys/purpose/vs-icon.svg";

import { track } from 'utils/amplitude';

interface IProps {
  item: {
    id?: string;
    name?: string;
    user?: string;
    is_private?: boolean;
    goal?: {
      id?: string;
      pleasure?: string;
      pain?: string;
      obstacles?: string;
      solutions?: string;
      category_name?: string;
      goal_name?: string;
    };
  };
  userData: {
    id?: string;
  };
  onChange: (id: string | undefined, field: string, value: string, callback?: () => void) => void;
}

const PurposeItem = forwardRef<HTMLDivElement, IProps>(({ item, userData, onChange }, ref) => {
  const isLocked = item?.is_private && userData?.id !== item?.user;

  return (
    <Wrapper>
      {isLocked && (
        <LockedOver customContent="This Goal is private" width="50px" />
      )}
      
      <Header>
        <HeaderTop>
          <Category>{item?.goal?.category_name}</Category>
          <Area>{item?.name}</Area>
        </HeaderTop>
        <Goal>{item?.goal?.goal_name}</Goal>
      </Header>

      <GroupLabel>Purpose</GroupLabel>
      <Group>
        <Col>
          <Item
            type={ItemType.Rewards}
            text={isLocked ? "" : item?.goal?.pleasure}
            area={item?.name}
            category={item?.goal?.category_name}
            goal_name={item?.goal?.goal_name}
            goal_id={item?.goal?.id}
            onChange={(type, value, callback) => {
              onChange(item?.id, 'pleasure', value, callback);
              
              // Amplitude tracking
              track("Goal Pleasure Entered", {
                goal_pleasure: value,
                goal_id: item?.id,
                with_ai: false
              });
            }}
          />
        </Col>
        <VsText>VS</VsText>
        <Col>
          <Item
            type={ItemType.Consequences}
            text={isLocked ? "" : item?.goal?.pain}
            area={item?.name}
            category={item?.goal?.category_name}
            goal_name={item?.goal?.goal_name}
            goal_id={item?.goal?.id}
            onChange={(type, value, callback) => {
              onChange(item?.id, 'pain', value, callback);
              
              // Amplitude tracking
              track("Goal Pain Entered", {
                goal_pain: value,
                goal_id: item?.id,
                with_ai: false
              });
            }}
          />
        </Col>
      </Group>

      <Divider />

      <GroupLabel>Strategy</GroupLabel>
      <Group>
        <Col>
          <Item
            type={ItemType.Obstacles}
            text={isLocked ? "" : item?.goal?.obstacles}
            area={item?.name}
            category={item?.goal?.category_name}
            goal_name={item?.goal?.goal_name}
            goal_id={item?.goal?.id}
            onChange={(type, value, callback) => {
              onChange(item?.id, 'obstacles', value, callback);
              
              // Amplitude tracking
              track("Goal Obstacles Entered", {
                goal_obstacles: value,
                goal_id: item?.id,
                with_ai: false
              });
            }}
          />
        </Col>
        <VsImage>
          <img src={vsIcon} alt="" />
        </VsImage>
        <Col>
          <Item
            type={ItemType.Solutions}
            text={isLocked ? "" : item?.goal?.solutions}
            area={item?.name}
            category={item?.goal?.category_name}
            goal_name={item?.goal?.goal_name}
            goal_id={item?.goal?.id}
            onChange={(type, value, callback) => {
              onChange(item?.id, 'solutions', value, callback);
              
              // Amplitude tracking
              track("Goal Solutions Entered", {
                goal_solutions: value,
                goal_id: item?.id,
                with_ai: false
              });
            }}
          />
        </Col>
      </Group>

    </Wrapper>
  )
});

export default PurposeItem;
